import React, { useState } from "react";
import styled from "styled-components";
import * as FaIcons from "react-icons/fa";
import * as Fa6Icons from "react-icons/fa6";
import * as RiIcons from "react-icons/ri";
import * as LuIcons from "lucide-react";

const iconLibraries = {
  FA: FaIcons,
  FA6: Fa6Icons,
  RI: RiIcons,
  LU: LuIcons,
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const Modal = styled.div`
  background: white;
  padding: 20px;
  width: 80%;
  max-width: 600px;
  height: 500px;
  overflow-y: auto;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
`;

const IconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
  gap: 10px;
  padding: 10px;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  &:hover {
    transform: scale(1.2);
  }
`;

const CloseButton = styled.button`
  background: red;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  float: right;
  border-radius: 3px;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
`;

const IconPicker = ({ onSelect, onClose }) => {
  const [search, setSearch] = useState(""); // Estado para o campo de pesquisa

  // Obtém todos os nomes dos ícones
  const iconNames = Object.keys(FaIcons);

  // Filtra os ícones com base no termo digitado pelo usuário
  const filteredIcons = iconNames.filter((iconName) =>
    iconName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Overlay>
      <Modal>
        <CloseButton onClick={onClose}>Fechar</CloseButton>
        <h3>Escolha um Ícone:</h3>
        <SearchInput
          type="text"
          placeholder="Pesquisar ícone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <IconGrid>
          {filteredIcons.map((iconName) => {
            const IconComponent = FaIcons[iconName];

            // Se o ícone não existir, não renderiza
            if (!IconComponent) return null;

            return (
              <IconButton key={iconName} onClick={() => onSelect(iconName)}>
                <IconComponent />
              </IconButton>
            );
          })}
        </IconGrid>
      </Modal>
    </Overlay>
  );
};

export default IconPicker;
